import { decryptString } from "@/helpers/userHelpers";
import { ActionTypes } from "../constants/action-types";
import { setCookie, getCookie } from "cookies-next";
import { isPWA } from "@/helpers/generalHelper";

let authCookie;
let userData;
let is_PWA = isPWA();
let checkForFirstVisit;

if (typeof window !== "undefined") {
  authCookie = getCookie('userdataToken');
    if (!authCookie) {
      authCookie = false;
      setCookie("is_new_customer",true, { maxAge: 6 * 30 * 24 * 3600 });
    } else {
      userData = sessionStorage.getItem('sAData');
      if (userData) {
        try {
          /* Decrypting user data and setting it in initial state */
          userData = decryptString(userData, JSON.parse(authCookie).accessToken);
          userData = JSON.parse(userData)
        }
        catch (e) {
          /* If json format is wrong due to unknown reason */
          // userData = null;
          console.error("User data is not in JSON format.", userData, e);
        }
      }
      authCookie =  JSON.parse(authCookie);
    }
  }

if (typeof window !== "undefined") {
  // if already value exists then first visit false else true
  if (localStorage.getItem("firstVisit") === "false") {
    checkForFirstVisit = false;
  } else {
    checkForFirstVisit = true;
  }
}

  const initialState = {
    user_loggedIn: authCookie,
    open_account_sidebar: false,
    open_account_sidebar_withMsg:"",
    open_account_sidebar_pwa_header:false,
    close_react_sidebar: false,
    userLoggedIn:userData,
    is_opening_account_sidebar : false,
    open_forgot_sidebar: true
    
  };
  
  export const userLoggedIn = (state = initialState, { type, payload }) => {
   
    switch (type) {
      case ActionTypes.LOGGEDIN_USER:
        return {
          ...state,
          userData: payload.userData,
          userLoggedIn: payload.userLoggedIn,
          yotpoDetails: payload.yotpoDetails
        };
      case ActionTypes.OPEN_ACCOUNT_SIDEBAR:
        return {
          ...state,
          open_account_sidebar: payload
        };
      case ActionTypes.OPEN_ACCOUNT_SIDEBAR_PWA_HEADER:
        return {
          ...state,
          open_account_sidebar_pwa_header: payload
        };
      case ActionTypes.OPEN_ACCOUNT_SIDEBAR_WITH_MSG:
        return{
          ...state,
          open_account_sidebar_withMsg:payload
        };
        case ActionTypes.UPDATE_AUTH:
        return{
          ...state,
        user_loggedIn:payload,
        }
        case ActionTypes.IS_OPENING_ACCOUNT_SIDEBAR:
          return {
            ...state,
            is_opening_account_sidebar : payload
          }
      case ActionTypes.CLOSE_REACT_SIDEBAR:
        return {
          ...state,
          close_react_sidebar : payload
        }
        case ActionTypes.OPEN_FORGOT_SIDEBAR:
          return {
            ...state,
            open_forgot_sidebar : payload
          }  
      default:
        return state;
    }
  };
  